import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { TYPE_POIRIER_SET } from '../../constants/booking';
import GeneralLocationSheet from './LocationSheets/GeneralLocationSheet';
import { renderSheets } from './CallsheetUtils';
import CallsheetHeader from './CallsheetHeader';
import { naturalSortKeys } from '../../helpers/callSheetHelpers';
import { onSitelocations } from '../../constants/callsheet';

class EverythingElseCallsheet extends Component {
  render() {
    const { bookings, date, renderForEmail, locationContacts } = this.props;
    let locationSheets = [];

    Object.entries(bookings).forEach((locationTypeEntry) => {
      const [locationTypeIdString, locations] = locationTypeEntry;
      const locationTypeId = parseInt(locationTypeIdString, 10);
      const filteredLocationContacts = locationContacts[locationTypeId];

      if (locationTypeId === TYPE_POIRIER_SET) {
        locationSheets = locationSheets.concat(
          renderSheets(
            GeneralLocationSheet,
            locations,
            renderForEmail,
            filteredLocationContacts
          )
        );
      }
    });

    const orderedSheets = [...locationSheets].sort(naturalSortKeys);

    return (
      <>
        <CallsheetHeader
          date={date}
          renderForEmail={renderForEmail}
          onSiteLocation={onSitelocations.POIRIER}
        />
        {orderedSheets}
      </>
    );
  }
}

EverythingElseCallsheet.propTypes = {
  bookings: PropTypes.objectOf(PropTypes.objectOf(PropTypes.object)).isRequired,
  date: PropTypes.instanceOf(Date).isRequired,
  renderForEmail: PropTypes.bool.isRequired,
  locationContacts: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.array])
  ).isRequired,
};

export default EverythingElseCallsheet;
